import { View } from 'react-native';
import { Text } from '@/components/ui/text';
import { Icon } from '~/global/components/icon/Icon';

export interface UnitChipProps {
  label: string;
  testID?: string;
}

/**
 * Presentational chip that triggers the serving-unit dropdown. Shared between the
 * web/Android (`UnitDropdown.tsx`) and iOS (`UnitDropdown.ios.tsx`) variants so the
 * trigger looks identical on every platform.
 */
export const UnitChip = ({ label, testID }: UnitChipProps) => (
  <View
    testID={testID}
    className="flex flex-row items-center gap-1.5 rounded-[10px] bg-surface-elevated px-3 py-2"
  >
    <Text className="text-[13px] font-inter-semibold text-text-primary">
      {label}
    </Text>
    <Icon name="ChevronsUpDown" size={12} className="text-text-muted" />
  </View>
);
